import React, { useState, useEffect } from "react";
import { database, ref, push, onValue, remove, update } from "./firebase";
import { useNavigate } from "react-router-dom";
import "./BillingSystem.css";
import BossNavigation from "./BossNavigation";
import Navigation from "./Navigation";

const products = [
  "Premium 2 Litre Bottle",
  "Premium 1 Litre Bottle",
  "Premium 500ML Bottle",
  "Premium 250ML Bottle",
  "Green 1 Litre Bottle",
  "Green 500ML Bottle",
  "250ML Pouch",
  "Packed Ice Cube (500 gm)"
];

export default function ProductionPage({ role }) {
  const [quantities, setQuantities] = useState(Array(products.length).fill(0));
  const [productionList, setProductionList] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const navigate = useNavigate();

  useEffect(() => {
    const prodRef = ref(database, "production");
    onValue(prodRef, (snapshot) => {
      const data = snapshot.val() || {};
      const formatted = Object.entries(data).map(([id, value]) => ({
        id,
        ...value
      }));
      setProductionList(formatted);
    });
  }, []);

  const handleQuantityChange = (index, value) => {
    const newQuantities = [...quantities];
    newQuantities[index] = parseInt(value) || 0;
    setQuantities(newQuantities);
  };

  const handleAddProduction = async () => {
    if (!quantities.some((q) => q > 0)) {
      alert("Enter product quantity");
      return;
    }

    const newProduction = {
      date,
      items: products
        .map((product, i) => ({ product, quantity: quantities[i] }))
        .filter((item) => item.quantity > 0)
    };

    await push(ref(database, "production"), newProduction);
    setQuantities(Array(products.length).fill(0));
    alert("Production added successfully");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this production record?")) {
      await remove(ref(database, `production/${id}`));
    }
  };

  const handleEdit = async (entry) => {
    const newItems = [...entry.items];
    for (let i = 0; i < newItems.length; i++) {
      const qty = prompt(
        `Edit quantity for ${newItems[i].product}`,
        newItems[i].quantity
      );
      newItems[i].quantity = parseInt(qty) || 0;
    }
    const newDate =
      prompt("Edit production date (YYYY-MM-DD)", entry.date) || entry.date;
    await update(ref(database, `production/${entry.id}`), {
      date: newDate,
      items: newItems
    });
  };

  return (
    <div className="container" style={{ paddingTop: "60px" }}>
      {/* ☰ Sidebar for role */}
      <Navigation role={role} />
      {role === "boss" && <BossNavigation />}

      {/* 🔧 Production Form */}
      <div className="section">
        <h2>🏭 Production Entry</h2>

        <div style={{ marginBottom: 20 }}>
          <label><strong>Select Date:</strong></label>
          <input
            type="date"
            value={date}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        {products.map((product, i) => (
          <div key={i} className="flex-row" style={{ marginBottom: 10 }}>
            <label style={{ flex: 2 }}>{product}</label>
            <input
              type="number"
              value={quantities[i]}
              onChange={(e) => handleQuantityChange(i, e.target.value)}
              style={{ flex: 1 }}
            />
          </div>
        ))}

        <button onClick={handleAddProduction}>➕ Add Production</button>
      </div>

      {/* 🔁 Previous Production */}
      <div className="section">
        <h4>📜 Previous Production Records</h4>
        {productionList
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .map((entry) => (
            <div key={entry.id} className="token-card">
              <strong>Date: {entry.date}</strong>
              <ul>
                {entry.items.map((item, idx) => (
                  <li key={idx}>
                    {item.quantity} × {item.product}
                  </li>
                ))}
              </ul>
              {(role === "owner" || role === "boss" || role === "production") && (
                <>
                  <button onClick={() => handleEdit(entry)}>✏️ Edit</button>
                  <button onClick={() => handleDelete(entry.id)}>🗑️ Delete</button>
                </>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}
